import {reducer} from './helpers'
import {GET_ORDERS_FAILURE, GET_ORDERS_SUCCESS} from '../actions/postCheckout'

import {CLEAR_EVENT_AND_ORDER_DETAILS} from '../actions/eventMgr'

const initialState = {
  hasError: false,
  orders: null,
}

export default reducer(initialState, (state, action) => {
  switch (action.type) {
    case GET_ORDERS_SUCCESS:
      return {
        orders: action.payload,
      }
    case GET_ORDERS_FAILURE:
      return {
        hasError: true,
        orders: null,
      }
    case CLEAR_EVENT_AND_ORDER_DETAILS:
      return {
        hasError: false,
        orders: null,
      }
    default:
      return null
  }
})
